import axios from "../tools/axiosHcp.js";

function saveStepData(url, model) {
	return axios.post(url, model);
}

function getEnrollmentForm(url, id) {
	return axios.get(`${url}Get?id=${id}`)
}

function getAll(url, status, query) {
	return axios.get(`${url}/GetAll?status=${status}${ query ? '&'+query : ''}`)
}

function dowloadFile(url) {
	return axios.get(`${url}`, { responseType: 'blob' })
}

function getFilters(url) {
	return axios.get(`${url}/GetEnrollmentFilters`)
}

function getComfortMedicalOrderDetails(url, id) {
	return axios.get(`${url}/api/cm/orders/details?id=${id}`)
}

function getComfortMedicalStatuses(url, params, { signal } = {}) {
	return axios.get(`${url}/api/cm/orders/status?${params}`, {
		signal,
	});
}

// will return query filters
function getQueryFilters(state) {
	const params = {};

	state.enrollmentFilters.forEach((group) => {
	  if (group.id === "date") {
		const [from, to] = group.data.map((d) => d.value);
		if (from) params.dateFrom = from;
		if (to) params.dateTo = to;
	  } else {
		const filters = group.data.filter((facet) => facet.checked);
		if (filters.length > 0) {
		  params[group.id] = filters.map((f) => f.value);
		}
	  }
	});

	if (state.searchTerm) {
	  params.searchTerm = state.searchTerm;
	}

	// return query as string
	return Object.entries(params)
	  .map(([key, value]) => `${key}=${value}`)
	  .join("&");
}

/*
* return Status name with first letter in lower case
* */
function getStatusName(status) {
	let currentStatus;
	if (status.indexOf(',') !== -1)
		currentStatus = status.split(',')[0].charAt(0).toLowerCase() + status.split(',')[0].slice(1);
	else
		currentStatus = status.charAt(0).toLowerCase() + status.slice(1);

	return currentStatus;
}


export default {
	saveStepData: saveStepData,
	getAll: getAll,
	getEnrollmentForm: getEnrollmentForm,
	dowloadFile: dowloadFile,
	getFilters: getFilters,
	getQueryFilters: getQueryFilters,
	getStatusName: getStatusName,
	getComfortMedicalOrderDetails: getComfortMedicalOrderDetails,
	getComfortMedicalStatuses: getComfortMedicalStatuses,
};
